export default __webpack_public_path__ + "static/media/interior8.1c1cf728.webp";